<template>
    <games-general-settings
        v-if="branch"
        :games-settings="branch.settings.games"
        :save-games-settings="(settings) => { save(settings); }"
    />
</template>
<script>
import state from '../../../../../../state';
import utils from '../../../../../../utils';
import branchService from '../../../../../../services/branch.service';

import GamesGeneralSettings from '../../../../../common/games-general-settings.vue';

export default {
    name: 'branch-games-general',
    components: { GamesGeneralSettings },
    data() {
        return {
            branch: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        },
        branchName() {
            return this.$route.params.branch;
        }
    },
    watch: {
        async clientId() {
            await this.loadBranch();
        },
        async branchName() {
            await this.loadBranch();
        }
    },
    async created() {
        await this.loadBranch();
    },
    methods: {
        async loadBranch() {
            let br = await branchService.get(this.clientId, this.branchName);
            this.branch = utils.clone(br);
        },
        async save(gamesSettings) {
            this.branch.settings.games = gamesSettings;
            await branchService.saveSettings(this.clientId, this.branch.branch, this.branch.settings);
            this.loadBranch();
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/branches/branch/games/branch-games-general-settings.vue